import type { DeepRequired } from '../fixtures.types'

const kbaAttempt: DeepRequired<KbaAttempt> = {
  __typename: 'KbaAttempt',
  attempt_id: 'TEST_ID',
  status: 'SUCCESS',
  questions: [],
}

export default kbaAttempt
